import React from 'react';

export default function Landing() {
  return(
    <h2>Landing Page!!!</h2>
  );
}